import { render, staticRenderFns } from "./gear-icon.svg.vue?vue&type=template&id=16337cb6&"
import script from "./gear-icon.svg.vue?vue&type=script&lang=js&"
export * from "./gear-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports